<template>
  <div style="position:relative">
    <div style="position:absolute" :class="{'block-opacity': awaitDataGet}"></div>
    <div  v-if="windowSize>=992" style="width:100%" class="d-none d-md-block"> 
        <div v-if="options"  :class="{'opacity-table': tableTable>=0 && typeof tableTable === 'number'}">
          <div v-if="tableGetFilter" style="position:relative">
            <slot name="filtrar">
            </slot>
            <b-icon icon="x"  @click="tableGetFilter=false" scale="1.2" style="position: absolute;right: 2px;top: 2px;color: #444;cursor:pointer"></b-icon>
          </div>
          <b-input-group
            size="sm"
            class="mb-3 sw-search"
            >
            <template v-slot:prepend> 
              <div style="border:1px solid #ced4da;border-bottom:none;border-top-left-radius:0.25rem" v-if="awaitDataGet">             
                <sw-loading></sw-loading>
              </div>  
              <div v-else>
                <b-button id="filtrarBtn" v-if="tableGetFilter===false" size="sm" style="border-top-left-radius:0.25rem" @click="tableGetFilter=!tableGetFilter" text="Button" variant="info" :disabled="!filterShow"><b-icon icon="filter" scale="1.2" ></b-icon><b-tooltip triggers="hover" noninteractive target="filtrarBtn" >Filtrar</b-tooltip></b-button> 

                <b-button size="sm" style="border-top-left-radius:0.25rem"  variant="info" @click="emitFiltrar"   v-if="tableGetFilter===true && filterShow">Filtrar</b-button>             

                <b-button size="sm"   @click="emitLimpiar" style="color: #17a2b8;border:1px solid #17a2b8;background:white"   v-if="tableGetFilter===true && filterShow">Limpiar</b-button> 
                
                <b-button size="sm"   @click="tableGetFilter=false" style="color: rgb(68, 68, 68);border:1px solid rgb(68, 68, 68);background:white"   v-if="tableGetFilter===true && filterShow">Cerrar</b-button>
                <b-button id="updateBtn" size="sm" @click="emitFiltrar" text="Button" variant="outline-primary"><b-icon icon="arrow-repeat" scale="1.2" ></b-icon><b-tooltip triggers="hover" noninteractive target="updateBtn" >Refrescar</b-tooltip></b-button> 
              </div> 
            </template>
            <b-input-group-prepend is-text>
              Buscar
            </b-input-group-prepend>
            <b-form-input :autofocus="saveConfig.autofocus" @input="inputSearchs" v-model="currentSearch" placeholder="Escribe aquí para filtrar los resultados"></b-form-input>
            <b-input-group-append>
              <b-button size="sm" text="Button" variant="info">txt</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button size="sm" @click="emitPdf" text="Button" variant="secondary">Pdf</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button size="sm" @click="emitExcell" text="Button" variant="success" class="search-radius">Excell</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div v-if="!options && buscarProp"  :class="{'opacity-table': tableTable>=0 && typeof tableTable === 'number'}">
          <b-input-group
            size="sm"
            class="mb-3 sw-search"
            >
            <b-input-group-prepend is-text>
              Buscar
            </b-input-group-prepend>
            <b-form-input :autofocus="saveConfig.autofocus" @input="inputSearchs" v-model="currentSearch" placeholder="Escribe aquí para filtrar los resultados" style="border-radius:0"></b-form-input>
          </b-input-group>
        </div>
        <table  style="margin-bottom:0" class="table table--get table-hover border box-effect linear">
          <thead  :class="{'opacity-table': tableTable>=0  && typeof tableTable === 'number' }">
            <tr v-if="showBtns()">
              <th  v-for="(items,index) in tableItems" :key="'thGet'+index" style="padding: 5px;vertical-align:top">
                <div v-if="items.thead.btn">
                  <div  :id="'Btn'+index" style="display:inline">
                    ({{selectBtn(index)}}) <b-icon :id="'optionsTableanular'+index" class="option-btn text-primary" icon="check2-square" scale="1.6" ></b-icon> 
                  </div> 
                  <b-popover
                      :target="'Btn'+index"
                      placement="bottom"
                      triggers="hover"
                    ><template v-slot:default>
                        <div class="text-center mt-3">
                          <b-button :disabled="selectBtn(index)<1 || tableTable>=0  && typeof tableTable === 'number'"  size="sm" @click="save('btn'+index,true)">  
                            {{items.thead.btn}} 
                          </b-button>
                        </div>
                      </template>  
                    </b-popover>             
                </div>
              </th>
              <th v-if="tableOptions.modals!==undefined || tableOptions.options!==undefined"></th>
            </tr>
            <tr>  
              <th v-for="(items,index) in tableItems" :key="'thGet'+index" style="vertical-align:top">  
                <b-row>
                  <b-col md="2" lg="2" v-if="items.thead.btn" style="margin-right:0.5rem">
                    <b-form-checkbox
                          v-model="thCheck"
                          size="lg"
                          @input="checkAll($event,'btn'+index)"
                        >
                    </b-form-checkbox> 
                  </b-col>
                  <b-col style="padding:0;">
                    {{items.thead.th}}         
                    <span @click="items.thead.sort=sort(items.thead.sort,items.thead.sortTable,index)" class="sw-sort" v-if="items.thead.sort!==undefined" :class="{'sw-sortdown': items.thead.sort===false, 'sw-sortup': items.thead.sort===true}">
                    </span>  
                  </b-col>
                </b-row> 
              </th>
              <th class="text-right"  style="vertical-align:top"  v-if="tableOptions.modals!==undefined || tableOptions.options!==undefined">
                <b-row>               
                  <b-col style="padding:0;">
                    Opciones 
                  </b-col>
                </b-row>   
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(items,index) in sortedTable()" :key="'dataGetTable'+index" style="position:relative;" :class="{'tableGet-warning': warningClass!==null &&  warningClass(items), 'tableGet-alert' : alertClass!==null &&  alertClass(items) }">
              <td v-if="items.tableTable!==undefined" :colspan="colspan()" class="bg-light box-effect linear">
                    <sw-tabletable
                        :tableItems="table.items"
                        :tableSearch="table.search"
                        :tableOptions="table.options"
                        :tableIndex="table.index"
                        :tabla="table.tabla"
                        :name="table.tabla"
                        @save="save"
                        >
                    </sw-tabletable>                  
              </td>
              <td style="position:relative" :class="{'opacity-table': (tableTable>=0 && tableTable!==items.index && opentabletable!==items2  && typeof tableTable === 'number') || awaitDataGet}" v-for="(items2,index2) in tableItems" :key="'tdGet'+index2" v-if="items.tableTable===undefined" >
                  <span style="position:absolute;font-size:13px;bottom:-1px;color:#856404;padding-left:43px;width:700px" v-if="index2===0 && alertClass!==null && alertClass(items)">
                    {{alertText(items)}}
                  </span>
                  <div v-if="items2.tbody.td" :class="items2.tbody.class">
                    <div v-if="!items2.thead.btn">
                      <div v-if="!items2.tbody.link">
                        <span v-if="!items2.tbody.ftn">
                          <span style="display: inline-block;" :class="{'pr-1': items2.tbody.td.length>1}"  v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4">
                            <span v-if="items2.tbody.checks">
                              <span v-if="items[items4]===true">
                                {{items2.tbody.checks[index4]}}  
                              </span>                  
                            </span>
                            <span v-else>
                              <span v-if="items4.includes('text/')">
                                  {{items4.replace('text/','')}}
                              </span>                              
                              <span v-else>
                                <span v-if="items2.tbody.show!==undefined && items[items2.tbody.show.td]==items2.tbody.show.compare">
                                  {{items[items4]}} 
                                </span>
                                <span v-if="items2.tbody.show===undefined">
                                  {{items[items4]}} 
                                </span>
                              </span>                                       
                            </span>
                          </span>
                        </span>
                        <span v-else>
                          <span v-if="items2.tbody.ftn!==undefined">
                                {{items2.tbody.ftn(propsFtn(items,items2.tbody.td))}}
                          </span>                          
                        </span>
                      </div>
                      <div v-else>
                        <div v-if="items[items2.tbody.td[0]]!==null && items[items2.tbody.td[0]]!=='' && items[items2.tbody.td[0]]!=='[]'">
                          <b-button v-if="items2.tbody.show===undefined" variant="white" size="sm" @click="openLinks(items2.tbody.link,items[items2.tbody.td[0]],items2.tbody.archivo)" class="btn-link">Pdf</b-button>
                          <b-button v-if="items2.tbody.show!==undefined && items[items2.tbody.show.td]==items2.tbody.show.compare" variant="white" size="sm" @click="openLinks(items2.tbody.link,items[items2.tbody.td[0]],items2.tbody.archivo)" class="btn-link">Pdf</b-button>
                          <span v-if="items2.tbody.show!==undefined && items[items2.tbody.show.td]!=items2.tbody.show.compare" >
                            {{items2.tbody.show.else}}
                          </span>
                        </div>
                      </div>                                    
                    </div>
                    <div v-if="items2.thead.btn">
                      <b-row>
                        <b-col md="2">
                          <b-form-checkbox
                                v-if="tableSave[name]!==undefined && tableSave[name]['btn'+index2]!==undefined"
                                size="lg"
                                v-model="tableSave[name]['btn'+index2][items.index].check"
                                @input="tableSave[name]['btn'+index2][items.index].index=items.index"
                              >
                          </b-form-checkbox>
                        </b-col>             
                        <sw-inputstable 
                          v-if="items2.tbody.input"
                          v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4"
                          :tablaCampo="items4"
                          :index="items.index"
                          :name="name"
                          :btn="'btn'+index2"
                          >
                        </sw-inputstable>
                        <b-col>
                           <span style="display: inline-block;"  v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4">                            
                              <span>
                                {{items[items4]}} 
                              </span>  
                          </span>
                        </b-col>   
                      </b-row>
                    </div>
                  </div>
                  <div v-if="items2.tbody.table && items[items2.tbody.table.tabla].length>0" style="position:relative">  
                      <b-icon :id="items.index+'popover'+index2"  @click="openTable(index,items2.tbody.table,items.index,index2);items.tableTable!=items.tableTable"  class="option-btn" icon="table" scale="1.3" variant="secondary"></b-icon>
                      <b-icon icon="shift-fill" scale="1.7" class="tableIcon" v-if="tableTable===items.index && opentabletable===index2 && !items2.thead.btn" rotate="180" variant="secondary"></b-icon>
                  </div>
              </td> 
              <td :class="{'opacity-table': (tableTable>=0  && typeof tableTable === 'number' &&  tableTable!==items.index && tableTable!==items.index) || awaitDataGet}" class="text-right" v-if="(tableOptions.options!==undefined || tableOptions.modals!==undefined) && items.tableTable===undefined">     
                  <div v-if="tableOptions.modals!==undefined"  style="display:inline-block;padding-left:5px;padding-right:5px">
                    <div v-for="(items3,index3) in tableOptions.modals" :key="'tableOptions'+index3" v-show="items3.showFtn===undefined || items3.showFtn(items)"  style="display:inline-block;padding-left:5px;padding-right:5px;margin-right:8px;margin-bottom:8px">
                        <b-icon @click="selectModal(items.index,items3);updateGlobal({state:'openModal/modal/variant', data: 'secondary'})" :id="items3.modal+index3+'Modal'+index" class="option-btn" :icon="items3.icon" scale="1.5" :variant="items3.variant"></b-icon>
                        <b-tooltip triggers="hover" noninteractive :target="items3.modal+index3+'Modal'+index">{{items3.modal}}</b-tooltip>
                    </div>
                  </div>   
                  <div style="display:inline-block;padding-left:5px;padding-right:5px" v-if="tableOptions.options!==undefined">
                    <div style="display:inline-block;padding-left:5px;padding-right:5px;margin-bottom:8px" v-if="tableOptions.options.editar!==undefined">
                      <b-icon  @click="selectModal(items.index,{modal: 'Editar', title: tableOptions.options.editar});updateGlobal({state:'openModal/modal/variant', data: 'primary'})" :id="'editarModal'+index" class="option-btn" icon="pencil" scale="1.5" variant="primary"></b-icon>
                      <b-tooltip triggers="hover" noninteractive :target="'editarModal'+index">Editar</b-tooltip>
                    </div> 
                    <div style="display:inline-block;padding-left:5px;padding-right:5px;margin-bottom:8px"  v-if="tableOptions.options.inactivar!==undefined">
                      <b-icon  @click="selectModal(items.index,{modal: 'Inactivar', title: tableOptions.options.inactivar});updateGlobal({state:'openModal/modal/variant', data: 'secondary'})"  :id="'inactivarModal'+index" class="option-btn" variant="dark" icon="toggle-on" scale="1.6" ></b-icon>
                      <b-tooltip triggers="hover" noninteractive :target="'inactivarModal'+index">Inactivar</b-tooltip>
                    </div>  
                    <div style="display:inline-block;padding-left:5px;padding-right:5px;margin-bottom:8px"  v-if="tableOptions.options.anular!==undefined">
                      <b-icon  @click="selectModal(items.index,{modal: 'Anular', title: tableOptions.options.anular});updateGlobal({state:'openModal/modal/variant', data: 'secondary'})"  :id="'anularModal'+index" class="option-btn text-inactive" icon="x-circle" scale="1.4" ></b-icon>
                      <b-tooltip triggers="hover" noninteractive :target="'anularModal'+index">Anular</b-tooltip>
                    </div>      
                    <div style="display:inline-block;padding-left:5px;padding-right:5px;margin-bottom:8px" v-if="tableOptions.options.eliminar!==undefined">
                      <b-icon  @click="selectModal(items.index,{modal: 'Eliminar', title: tableOptions.options.eliminar});updateGlobal({state:'openModal/modal/variant', data: 'secondary'})" :id="'eliminarModal'+index" class="option-btn" icon="trash" scale="1.5" variant="danger"></b-icon>
                      <b-tooltip triggers="hover" noninteractive :target="'eliminarModal'+index">Eliminar</b-tooltip>
                    </div>
                  </div>                
              </td>
            </tr>
          </tbody>
        </table>
        <b-row v-if="paginationShow" :class="{'opacity-table': (tableTable>=0  && typeof tableTable === 'number') || awaitDataGet }" >    
          <b-col md="3" class="p-0">
            <b-pagination style="margin-bottom:0" class="paginatableget" v-model="pagination" :total-rows="rows" size="sm" first-number  align="fill"></b-pagination>
          </b-col> 
          <b-col  class="p-0">            
          </b-col>
        </b-row>              
    </div>
    <div  v-if="windowSize<992" style="width:100%" class="d-md-none"> 
      <div  :class="{'opacity-table': tableTable>=0 && typeof tableTable === 'number'}">
        <div v-if="tableGetFilter" style="position:relative">
          <slot name="filtrar">
          </slot>
          <b-icon icon="x"  @click="tableGetFilter=false" scale="1.2" style="position: absolute;right: 2px;top: 2px;color: #444;cursor:pointer"></b-icon>
        </div>
        <b-input-group
          size="sm"
          class="mb-3 sw-search"
        >
          <template v-slot:prepend>        
            <b-button id="filtrarBtn" v-show="tableGetFilter===false" size="sm" style="border-bottom-left-radius:0" @click="tableGetFilter=!tableGetFilter" text="Button" variant="info"><b-icon icon="filter" scale="1.2"></b-icon></b-button> 
            <b-button size="sm"  variant="info" @click="emitFiltrar"   v-show="tableGetFilter===true">Filtrar</b-button>             
            <b-tooltip triggers="hover" noninteractive target="filtrarBtn" >Filtrar</b-tooltip>
            <b-button size="sm"   @click="emitLimpiar" style="color: #17a2b8;border:1px solid #17a2b8;background:white"   v-show="tableGetFilter===true">Limpiar</b-button> 
            <b-button size="sm"   @click="tableGetFilter=false" style="color: rgb(68, 68, 68);border:1px solid rgb(68, 68, 68);background:white"   v-show="tableGetFilter===true">Cerrar</b-button> 
          </template>
          <b-form-input :autofocus="saveConfig.autofocus" @input="inputSearchs" v-model="currentSearch" placeholder="Buscar"></b-form-input>
          <b-input-group-append>
            <b-button size="sm" v-show="tableGetFilter!==true" text="Button" variant="info">txt</b-button>
          </b-input-group-append>
          <b-input-group-append>
            <b-button size="sm" v-show="tableGetFilter!==true" text="Button" variant="secondary">Pdf</b-button>
          </b-input-group-append>
          <b-input-group-append>
            <b-button size="sm" v-show="tableGetFilter!==true" text="Button" variant="success" class="search-radius">Exc</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <table   style="margin-bottom:0" class="table table--get table-hover border box-effect linear">
        <thead>
          <tr>
            <th  v-for="(items,index) in tableItems" :key="'thGetMovil'+index" v-if="items.thead.movil">{{items.thead.th}}</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr :class="{'tableGet-warning': warningClass!==null &&  warningClass(items), 'tableGet-alert' : alertClass!==null &&  alertClass(items) }" v-for="(items,index) in sortedTable()" :key="'dataGetTableMovil'+index" style="position:relative;">
            <td   v-for="(items2,index2) in tableItems" :key="'thGetMovil'+index2" v-if="items2.thead.movil && items.tableTable===undefined">              
              <span v-if="items2.tbody.ftn!==undefined">
                    {{items2.tbody.ftn(propsFtn(items,items2.tbody.td))}}
              </span> 
              <span v-else>
                {{items[items2.tbody.td[0]]}}
              </span>              
            </td>
            <td style="background: #f0f0f0" :colspan="colspan()"  v-if="items.tableTable!==undefined">
              <div  v-if="tableOptions.modals!==undefined" style="padding-bottom: 7px; text-align: center;">
                <div  style="display:inline-block;padding-left:5px;padding-right:5px">
                  <div v-for="(items3,index3) in tableOptions.modals" :key="'tableOptions'+index3" v-show="items3.movil && (items3.showFtn===undefined || items3.showFtn(items))"  style="display:inline-block;padding-left:5px;padding-right:5px;margin-right:8px">
                      <b-icon @click="selectModal(items.index-1,items3);updateGlobal({state:'openModal/modal/variant', data: 'secondary'})" class="option-btn" :icon="items3.icon" scale="1.7" :variant="items3.variant"></b-icon>                      
                  </div>
                </div> 
                <div style="display:inline-block;padding-left:5px;padding-right:5px" v-if="tableOptions.options!==undefined && tableOptions.options.editar!==undefined">
                  <b-icon  @click="openModalTable=true;selectModal(items.index-1,items3);updateGlobal({state:'openModal/modal/variant', data: 'secondary'})"  class="option-btn" icon="pencil" scale="1.7" variant="primary"></b-icon>
                </div> 
                <div style="display:inline-block;padding-left:5px;padding-right:5px"  v-if="tableOptions.options!==undefined && tableOptions.options.inactivar!==undefined">
                  <b-icon  @click="openModalTable=true;selectModal(items.index-1,{modal: 'Inactivar', title: tableOptions.options.inactivar});updateGlobal({state:'openModal/modal/variant', data: 'secondary'})" class="option-btn" variant="dark" icon="toggle-on" scale="1.8" ></b-icon>
                </div>  
                <div style="display:inline-block;padding-left:5px;padding-right:5px"  v-if="tableOptions.options!==undefined && tableOptions.options.anular!==undefined">
                  <b-icon  @click="openModalTable=true;selectModal(items.index-1,{modal: 'Anular', title: tableOptions.options.anular});updateGlobal({state:'openModal/modal/variant', data: 'secondary'})"  class="option-btn text-inactive" icon="slash-circle" scale="1.6" ></b-icon>
                </div>      
                <div style="display:inline-block;padding-left:5px;padding-right:5px" v-if="tableOptions.options!==undefined && tableOptions.options.eliminar!==undefined">
                  <b-icon  @click="openModalTable=true;selectModal(items.index-1,{modal: 'Eliminar', title: tableOptions.options.eliminar});updateGlobal({state:'openModal/modal/variant', data: 'secondary'})" class="option-btn" icon="trash" scale="1.7" variant="danger"></b-icon>
                </div>
              </div>
              <table style="width:100%">
                <tbody>
                  <tr  style="background: white" v-for="(items2,index2) in tableItems" :key="'thGetMovil2'+index2" v-if="items2.thead.movil===undefined">
                    <td>{{items2.thead.th}} :</td>
                    <td>
                      <div v-if="items2.tbody.td">
                        <div v-if="!items2.thead.btn">
                          <div v-if="!items2.tbody.link">
                              <span v-if="!items2.tbody.ftn">
                                <span  style="display: inline-block;" v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4">
                                  <span v-if="items2.tbody.checks">
                                    <span v-if="items[items4]===true">
                                      {{items2.tbody.checks[index4]}}  
                                    </span>                  
                                  </span>
                                  <span v-else>
                                    <span v-if="items4.includes('text/')">
                                        {{items4.replace('text/','')}}
                                    </span>
                                    <span v-if="items[items4]!==null">
                                      {{items[items4]}} 
                                    </span>                                       
                                  </span>
                                </span>  
                              </span>
                              <span v-if="items2.tbody.ftn!==undefined">
                                    {{items2.tbody.ftn(propsFtn(items,items2.tbody.td))}}
                              </span> 
                          </div>
                          <div v-else>
                            <b-button variant="white" size="sm" @click="openLinks(items2.tbody.link,items[items2.tbody.td[0]],items2.tbody.archivo)" class="btn-link">Pdf</b-button>
                          </div>                                    
                        </div>
                        <div v-if="items2.thead.btn">
                          <b-row>
                            <b-col md="2">
                              <b-form-checkbox
                                    size="lg"
                                    v-model="tableSave[name]['btn'+index2][items.index].check"
                                  >
                              </b-form-checkbox>
                            </b-col>                
                            <sw-inputstable
                              v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4"
                              :tablaCampo="items4"
                              :index="items.index"
                              :name="name"
                              :btn="'btn'+index2"
                              >
                            </sw-inputstable>
                          </b-row>
                        </div>
                      </div>
                      <div v-if="items2.tbody.table && items[items2.tbody.table.tabla].length>0" style="position:relative">  
                          <b-icon :id="items.index+'popover'+index2"  @click="openTableModal(items2.tbody.table,items.index,items2.thead.th)"  class="option-btn" icon="table" scale="1.3" variant="secondary"></b-icon>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td  v-if="items.tableTable===undefined">
              <div style="display:inline-block;padding-left:5px;padding-right:5px">
                <div style="display:inline-block;padding-left:5px;padding-right:15px">
                  <b-icon class="option-btn" icon="list-ul" scale="1.7" variant="secondary" @click="openTableMovil(index,items);items.tableTable!=items.tableTable"></b-icon>
                </div>
              </div>     
            </td>
          </tr>
        </tbody>
      </table>      
      <b-modal 
            v-if="openModalTable"
            v-model="openModal.modal.value"
            :title="openModal.modal.title" 
            :header-bg-variant="openModal.modal.variant"
            header-text-variant="light"
            :hide-footer="true"  
            :no-close-on-backdrop="true" 
            @hide="openModalTable=false"
            size="lg"  
            >           
              <sw-tabletable
                  :tableItems="table.items"
                  :tableSearch="table.search"
                  :tableOptions="table.options"
                  :tableIndex="table.index"
                  :tabla="table.tabla"
                  :name="table.tabla"
                  @save="save"
                  >
              </sw-tabletable>       
          </b-modal> 
    </div>
    <b-modal 
        v-if="openModalshow"
        v-model="openModal.modal.value"
        :title="openModal.modal.title" 
        :header-bg-variant="openModal.modal.variant"
        header-text-variant="light"
        :hide-footer="true"  
        :no-close-on-backdrop="true" 
        @hide="openModalshow=false"
        size="lg"  
        >           
          <slot name="modal">
          </slot>       
      </b-modal> 
  </div>
</template>
<script>
import SwTabletable from '@/components/dataTable/tableTable.vue'
import SwInputstable from '@/components/forms/inputsTable.vue'
import SwLoading from '@/components/notification/loading.vue'
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
function cleanParameter(value)
  {
    if(value==null)
    {
      return '';
    }
    return value.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  }
export default 
{
  name: 'swTableget',
  components: { SwInputstable, SwTabletable, SwLoading  },
  props: {
    tableSearch: {
      type: Array,
      default: function()
      {
        return []
      }
    },
    tableItems: {
      type: Array,
      default: function()
      {
        return []
      }
    },
    tableOptions: {
      type: Object,
      default: function()
      {
        return {}
      }
    },
    name: {
      type: String,
      default: ''
    },
    route: {
      type: String,
      default: ''
    },
    dataRoute: {
      default: ''
    },
    filterShow: {
      type: Boolean,
      default: true
    },
    options: {
      type: Boolean,
      default: true
    },
    warningClass: {
      default : null
    },
    alertClass: {
      default : null
    },
    alertText: {
      default : null
    },
    buscarProp: {
      type: Boolean,
      default: true
    },
    paginationShow: {
      type: Boolean,
      default: true
    }

  },
  data () {
    return {
      currentSearch:'',
      currentSort:'id',
      currentSortDir: '', 
      tableTable: true, 
      opentabletable: false,
      openModalshow:false,
      openModalTable: false,
      table: {  
        items: [],
        search: [],
        options: {},
        name: '',
        index: 0,
      },
      pagination: 1,
      rows: 20,
      tableGetFilter: true,
      dataGetLength:0,
      thCheck: false     
    }
  },
  async created() { 
    if(this.produccion===false && this.route!=='')
    {
      await this.getDataGet({route: this.route, data: this.dataRoute})

      let checks = await this.asignTableSave(this.dataGet[this.namePath].data)
      this.updateCrud({state: 'tableSave', data: checks})       
    }
  },
  async updated()
  {        
    if(this.dataGet[this.namePath].data.length!==this.dataGetLength)
    {                   
      let checks = await this.asignTableSave(this.dataGet[this.namePath].data)
      this.updateCrud({state: 'tableSave', data: checks})  
      this.dataGetLength=this.dataGet[this.namePath].data.length
    }
  },
  computed: {    
  },
  methods: { 
    propsFtn(items,td)
    {
      let arrayItems= []
      for (let i = 0; i < td.length; i++) {
        arrayItems.push(items[td[i]])        
      }
      if(td.length>1)
      {
        return arrayItems
      }
      return items[td[0]]
      
    },
    // COMPUTADOS O INICIALES
      async asignTableSave(data)
      {     
        let checks = {} 
        checks[this.name]= {}   
        for (let m = 0; m < data.length; m++) 
        {               
          for(let i=0; i<this.tableItems.length;i++)
          {
            if(this.tableItems[i].thead.btn!==undefined && this.tableItems[i].thead.btn!=='')
            {
              if(checks[this.name]['btn'+i]===undefined)  
              {
                  checks[this.name]['btn'+i]=[]
              }
              checks[this.name]['btn'+i][m]={}
              checks[this.name]['btn'+i][m].id=m
              checks[this.name]['btn'+i][m].check=false
              checks[this.name]['btn'+i][m].index=false

              if(this.tableItems[i].tbody.campos && data[m].table===undefined) 
              {
                for (let j = 0; j < this.tableItems[i].tbody.campos.length; j++) {                  
                  let tablaCampo= this.tableItems[i].tbody.campos[j].split('/')
                  if(checks[this.name]['btn'+i][m][tablaCampo[0]]===undefined)  
                  {
                    checks[this.name]['btn'+i][m][tablaCampo[0]]={}
                  }
                  checks[this.name]['btn'+i][m][tablaCampo[0]].id=data[m][tablaCampo[0]].id
                  checks[this.name]['btn'+i][m][tablaCampo[0]][tablaCampo[1]]=data[m][tablaCampo[0]][tablaCampo[1]]
                }              
              }
              else if(this.tableItems[i].tbody.campos===undefined && data[m].table===undefined)
              {
                for (let j = 0; j < this.tableItems[i].tbody.td.length; j++) {
                  let tablaCampo= this.tableItems[i].tbody.td[j].split('/')
                  if(checks[this.name]['btn'+i][m][tablaCampo[0]]===undefined)  
                  {
                    checks[this.name]['btn'+i][m][tablaCampo[0]]={}
                  }
                  checks[this.name]['btn'+i][m][tablaCampo[0]].id=data[m][tablaCampo[0]].id
                  checks[this.name]['btn'+i][m][tablaCampo[0]][tablaCampo[1]]=data[m][tablaCampo[0]][tablaCampo[1]]
                } 
              }      
            }
            else{    
              if(this.tableItems[i].tbody.table!==undefined)
              {           
                if(this.tableTable===false)
                {
                  this.tableTable=true
                }
              } 
            }
          } 
        } 
        return checks
      },
      sortedTable()
      {
        let vm = this;
        let popoverMap = []      
          let dataFilter = this.deepCopyTable(this.dataGet[this.namePath].data).filter(list => {
            return this.tableSearch.find( items => {
                return cleanParameter(list[items]).indexOf(cleanParameter(this.currentSearch)) > -1
              })         
          })   
          return dataFilter.sort((a,b) => {
            let modifier = 1;
            if(this.currentSortDir === 'desc') modifier = -1;
            if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier
            if(a[this.currentSort] > b[this.currentSort]) return  1 * modifier
            return 0
          }); 
      },  
      sort(sort,td,index){ 
        for(var i=0;i<this.tableItems.length;i++)
        {
          if(index!==i)
          {
            if(this.tableItems[i].thead.sort!==undefined)
            {
              this.tableItems[i].thead.sort=null
            }          
          }        
        }
        this.currentSort=td  
        this.currentSortDir = 'desc'
        if(sort===null || sort===false)
        {
          this.currentSortDir = 'asc'
          return true
        }
        return !sort
      },
      colspan()
      {        
        let colspan=0
        if(this.tableOptions.options || this.tableOptions.modals)
        {
          colspan=1
        }
        return colspan + this.tableItems.length
      },
    // GLOBALES Y REUTILIZABLES

    // MEDIANTE UNA ACCION    
      async inputSearchs()
      {
        if(this.tableTable>=0 && typeof this.tableTable === 'number')
        {
            await this.spliceDataGet(this.tableTable+1)
            this.tableTable=true
            this.openModalTable=false
        }         
      },
      openLinks(link,id,archivo)
      {
        if(archivo===undefined)
        {
          window.open( this.url+link+'?id='+id+'&token='+this.token,'_blank')
        }
        else 
        {
          id=JSON.parse(id)
          if(id.length>1)
          {
            window.open( this.url+'/api/pdf/archivos?data='+id+'&token='+this.token,'_blank')
          }
          else 
          {          
            if(id[0].includes('.pdf'))
            {
              window.open( this.url+link+'/'+id[0],'_blank')
            } 
            else 
            {
              window.open( this.url+'/api/pdf/archivos?data='+id+'&token='+this.token,'_blank')
            } 
            
          }
        }       
      },
      showBtns()
      {
        return this.tableItems.find(list => list.thead.btn!==undefined && list.thead.showBtn!==false)       
      },
      selectBtn(btn)
      {        
        if(this.tableSave[this.name]!==undefined && this.tableSave[this.name]['btn'+btn]!==undefined) 
        {
          let selectBtnLength = this.tableSave[this.name]['btn'+btn].filter( list => list.check)
          return selectBtnLength.length  
        }      
          return 0  
      },
      checkAll(event,btn)
      {
        if(this.tableSave[this.name]!==undefined && this.tableSave[this.name][btn]!==undefined)
        {
          for (let i = 0; i < this.tableSave[this.name][btn].length; i++) {
            this.changeCrud({state: 'tableSave/'+this.name+'/'+btn+'/'+i+'/check', boolean: event})        
          }
        }
        return true
      },
      async selectModalMovil(index,modal)
      {
        await this.resetDataForm()
        this.openModalTable=true;
        
        await this.updateDataIndex({data: index});
        await this.updateGlobal({state: 'openModal/modal/title',    data: modal.title});
        await this.updateGlobal({state: 'openModal/modal/modal',    data: modal.modal}); 
        await this.updateGlobal({state: 'openModal/modal/value',    data: true });     
      },
      async selectModal(index,modal)
      {
        await this.resetDataForm()
        this.openModalshow=true;
        if(this.tableTable!==false)
        { 
          if(this.tableTable>=0 && typeof this.tableTable === 'number')
          {
            await this.spliceDataGet(this.tableTable+1)
            this.tableTable=true
          }
        }
        await this.updateDataIndex({data: index});
        await this.updateGlobal({state: 'openModal/modal/title',    data: modal.title});
        await this.updateGlobal({state: 'openModal/modal/modal',    data: modal.modal}); 
        await this.updateGlobal({state: 'openModal/modal/value',    data: true });     
      },
      async openTableModal(table,itemIndex,title)
      {
        this.table=table
        this.table.index=itemIndex
        
        let checks = await this.asignTableSave(this.dataGet[this.namePath].data)
        await this.updateCrud({state: 'tableSave', data: checks})
        
        await this.updateGlobal({state: 'openModal/modal/title',    data: title})
        await this.updateGlobal({state: 'openModal/modal/modal',    data: title}) 
        await this.updateGlobal({state: 'openModal/modal/value',    data: true });
        
        this.openModalTable=true 
      },
      async openTable(index,table,itemIndex,indexopen)
      {
        let searchTableTable={}
        searchTableTable.tableTable=false
        let campoytabla
        for (let i = 0; i < this.tableSearch.length; i++) {
          searchTableTable[this.tableSearch[i]] = this.sortedTable()[index][this.tableSearch[i]]       
        }
        if(this.tableTable!==false) //si existe una table en el td
        {    
          if(this.tableTable!==true) // si esta abierta alguna table
          {
            await this.spliceDataGet(this.tableTable+1)
            let keysTableSave= Object.keys(this.tableSave[this.name])
            for (let i = 0; i < keysTableSave.length; i++) {
                this.tableSave[this.name][keysTableSave[i]].splice(itemIndex+1,1)            
            }
          }
          if(itemIndex!==this.tableTable) // si la posicion del tr es diferente a la del tr con el table abierto
          {
            this.opentabletable=indexopen

            if(index>this.tableTable && this.tableTable!==true)
            {
              index=index-1
              itemIndex=itemIndex-1
            }
            this.dataGet[this.namePath].data.splice(itemIndex+1,0,searchTableTable)  
            this.tableTable = itemIndex
            this.table=table
            this.table.index=itemIndex   
            let checks = await this.asignTableSave(this.dataGet[this.namePath].data)
            await this.updateCrud({state: 'tableSave', data: checks}) 
          }
          else{
            if(this.opentabletable===indexopen)
            {
              this.tableTable=true
            }
            else{
              this.opentabletable=indexopen
              if(index>this.tableTable && this.tableTable!==true)
              {
                index=index-1
                itemIndex=itemIndex-1
              }
              this.dataGet[this.namePath].data.splice(itemIndex+1,0,searchTableTable)  
              this.tableTable = itemIndex
              this.table=table
              this.table.index=itemIndex
              
              let checks = await this.asignTableSave(this.dataGet[this.namePath].data)
              await this.updateCrud({state: 'tableSave', data: checks})
            }          
          } 
        }        
      },
      async openTableMovil(index,table)
      {
        let indexopen=1
        let itemIndex=table.index
        let searchTableTable=table
        searchTableTable.tableTable=false
        let campoytabla        
        if(this.tableTable!==false) //si existe una table en el td
        {    
          if(this.tableTable!==true) // si esta abierta alguna table
          {
            await this.spliceDataGet(this.tableTable+1)
            let keysTableSave= Object.keys(this.tableSave[this.name])
            for (let i = 0; i < keysTableSave.length; i++) {
                this.tableSave[this.name][keysTableSave[i]].splice(itemIndex+1,1)            
            }
          }
          if(itemIndex!==this.tableTable) // si la posicion del tr es diferente a la del tr con el table abierto
          {
            this.opentabletable=indexopen

            if(index>this.tableTable && this.tableTable!==true)
            {
              index=index-1
              itemIndex=itemIndex-1
            }
            this.dataGet[this.namePath].data.splice(itemIndex+1,0,searchTableTable)  
            this.tableTable = itemIndex
          }
          else{
            if(this.opentabletable===indexopen)
            {
              this.tableTable=true
            }
            else{
              this.opentabletable=indexopen
              if(index>this.tableTable && this.tableTable!==true)
              {
                index=index-1
                itemIndex=itemIndex-1
              }
              this.dataGet[this.namePath].data.splice(itemIndex+1,0,searchTableTable)  
            }          
          } 
        }
      },   
    // EVENTOS
      async emitLimpiar()
      { 
        this.thCheck=false
        this.resetCrud({state: 'tableSave'}) 
        await this.$emit('limpiar')
      },
      async emitFiltrar()
      { 
        await this.$emit('filtrar')
      },
      async save(data,btn=false)
      {         
        if(btn===true)
        {  
            let valuesForm= {}      
            for (let i = 0; i < this.tableSave[this.name][data].length; i++) {
              if(this.tableSave[this.name][data][i].check===true)
              {
                let objectKeys= Object.keys(this.tableSave[this.name][data][i]) 
                for (let j = 0; j < objectKeys.length; j++) {
                  if(objectKeys[j]!=='id' && objectKeys[j]!=='check') { 
                      if(valuesForm[objectKeys[j]]===undefined)
                      {
                        valuesForm[objectKeys[j]]=[]                        
                        await this.updateDataForm({state: objectKeys[j],data: [] })		
                      }
                      valuesForm[objectKeys[j]].push(this.tableSave[this.name][data][i][objectKeys[j]])
                        await this.pushDataForm({state: objectKeys[j],data: this.tableSave[this.name][data][i][objectKeys[j]] })	
                  }              
                }
              }             
            }				
        }
        await this.inputSearchs()
        await this.$emit('save',{save:false,ftn:data})
      },
      emitPdf()
      {        
        this.$emit('pdf')
      },
      emitExcell()
      {
        this.$emit('excell')
      }
  }
}
</script>
<style>
.sw-search{
  margin-bottom: 0 !important
}
.sw-search .input-group-text {
    border-radius: 0 0 0 0 !important;
}
.sw-search .search-radius{
    border-radius:  0 0.25rem 0 0 !important;
}
.table--get > thead tr{
  border-left: 1px solid #ced4da;
  border-right: 1px solid #ced4da;
}
.table--get > thead tr th{
    color: #495057;
    background-color: #e9ecef;
    vertical-align: bottom;
    border-bottom: 1px solid #dee2e6;
    border-top: none;
}
.sw-sort{
  background-image: url('/images/sort.svg');
  width: 11px;
  height: 18px;
  float: right;
  background-size: cover;
  margin-top: 3px;
  cursor:pointer;
}
.sw-sortdown{
  background-image: url('/images/sortdown.svg');
}
.sw-sortup{
  background-image: url('/images/sortup.svg');
}
.tableIcon{
    position: absolute;
    bottom: -22px;
    left: 0;
    color: #525173 !important;
}
.paginatable .page-link{
  color: #495057 ;
}
.paginatableget .active .page-link{
  background: #6c757d ;
  border-color:#6c757d;
}
.paginatableget .page-link{
  border-top: none;
}
.paginatableget .page-link:focus{
    box-shadow: none;
}
.paginatableget .page-item span:first-child{
  border-top-left-radius:0 !important;
}
.paginatableget .page-item:last-child .page-link{
  border-top-right-radius:0 !important;
}
.opacity-table{
  opacity: 0.3
}
.table--get{
  font-size: 13.3px;
}
.table--get > thead tr th{
  padding: 2px
}
.table--get > tbody tr td{
  text-transform:uppercase;
  padding: 5px 2px
}
.input-group-prepend .btn
{
  border-radius:0 
}
.tableGet-warning {
  background: rgba(240,83,53,0.1) ;
}
.tableGet-alert {
  background: #ffc10734;
}
.block-opacity{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
}

</style>